// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"9e00ac9c","812":"f3917851"}[chunkId] + ".chunk.js";
};